import { AccordionGroup, Box, Divider, useIntl } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import { MobileLabelMessages } from '../../layouts/mobileScreens/messages';

export function MobileBlotter({
  titleKey,
  children,
}: PropsWithChildren<{ titleKey: keyof typeof MobileLabelMessages }>) {
  const { formatMessage } = useIntl();
  return (
    <AccordionGroup>
      <Box p="spacing12" color="colorTextImportant" data-testid={`mobile-blotter-${titleKey}`}>
        {formatMessage(MobileLabelMessages[titleKey])}
      </Box>
      <Divider />
      {children}
    </AccordionGroup>
  );
}
